import { Button, ListItem, ListItemText } from '@mui/material'
import type { PrizeToImport } from 'types/Prize'
import { useState } from 'react'
import { CopyCodeIcon } from 'assets/icons/copy-code'

export const PrizeElement = ({ prize }: { prize: PrizeToImport }) => {
  const [isCopied, setIsCopied] = useState(false)

  const copyHandler = async (text: string): Promise<void> => {
    setIsCopied(true)
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text)
    } else {
      document.execCommand('copy', true, text)
    }

    setTimeout(() => {
      setIsCopied(false)
    }, 500)
  }

  return (
    <ListItem
      sx={theme => ({
        display: 'flex',
        gap: 2,
        padding: 0,
      })}
      disableGutters
    >
      <ListItemText
        sx={{
          backgroundColor: 'background.default',
          borderRadius: 2,
          border: '1px dashed #D4D4D4',
          padding: '6px 16px',
        }}
        primaryTypographyProps={{
          lineHeight: 1.25,
          color: '#535353',
        }}
        primary={`${prize.translations[0]?.translation ?? 'n/a'}: ${prize.name}`}
      />

      <Button
        variant="outlined"
        color="secondary"
        size="medium"
        disabled={isCopied}
        onClick={async () => {
          await copyHandler(prize.name)
        }}
        startIcon={<CopyCodeIcon />}
        sx={{ textTransform: 'none' }}
      >
        {isCopied ? 'Copied...' : 'Copy'}
      </Button>
    </ListItem>
  )
}
